import { useContext } from 'react';
import { Anchor, Box, Paragraph } from '@zillow/constellation-10';
import type { SatelliteWebLandlordLeadManagementTableListingDetailsDto } from '@zg-rentals/ts-satellite-client';
import { AppContext } from '../../../../contexts/AppContextProvider';
import formatListingAddress from '../../../../utils/formatListingAddress';
import getPropertyDashboardOverviewUrl from '../../../../utils/getPropertyDashboardOverviewUrl';

type ListingAddressProps = {
  listingDetails: SatelliteWebLandlordLeadManagementTableListingDetailsDto;
  singleLine?: boolean;
};

export default function ListingAddress({ listingDetails, singleLine }: ListingAddressProps) {
  const { paths } = useContext(AppContext);
  const { streetAddress, cityStateZip } = listingDetails.address;
  const href = getPropertyDashboardOverviewUrl(paths.myPropertiesPageWithBasePath, listingDetails.listingAlias);

  if (!streetAddress) return null;

  const fullAddress = formatListingAddress(listingDetails.address);

  if (singleLine) {
    return (
      <Paragraph textStyle="body-sm" css={{ truncate: true }}>
        <Anchor href={href} aria-label={`View property details for ${fullAddress}`}>
          {fullAddress}
        </Anchor>
      </Paragraph>
    );
  }

  return (
    <Box>
      <Paragraph textStyle="body-sm" css={{ truncate: true }}>
        <Anchor href={href} aria-label={`View property details for ${fullAddress}`}>
          {streetAddress}
        </Anchor>
      </Paragraph>
      {cityStateZip && (
        <Paragraph textStyle="body-xs" css={{ color: 'text.subtle', truncate: true }}>
          {cityStateZip}
        </Paragraph>
      )}
    </Box>
  );
}
